module.exports = __webpack_public_path__ + "img/map-bajo@2x.06fbbb40.png";